import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LawController::privacy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: '/ochrana-osobnich-udaju',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LawController::privacy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LawController::privacy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LawController::privacy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:20
* @route '/cookies'
*/
export const cookies = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

cookies.definition = {
    methods: ["get","head"],
    url: '/cookies',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:20
* @route '/cookies'
*/
cookies.url = (options?: RouteQueryOptions) => {
    return cookies.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:20
* @route '/cookies'
*/
cookies.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:20
* @route '/cookies'
*/
cookies.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cookies.url(options),
    method: 'head',
})

const LawController = { privacy, cookies }

export default LawController